const IconContainer = ({
  Icon,
  isClickable = true,
  label,
  onClick,
  size = 24,
  color = 'black',
  className = '',
  tooltipPlace = 'bottom',
}) => {
  return (
    <>
      {isClickable ? (
        <button
          onClick={onClick}
          className={`icon iconButton ${className}`}
          style={{ padding: size / 4 }}
          data-tooltip-id={label ? 'icon-tooltip' : undefined}
          data-tooltip-content={label}
          data-tooltip-place={tooltipPlace}
        >
          {Icon && <Icon width={size} height={size} style={{ fill: color, color }} />}
        </button>
      ) : (
        <div
          className={`icon ${className}`}
          data-tooltip-id={label ? 'icon-tooltip' : undefined}
          data-tooltip-content={label}
          data-tooltip-place={tooltipPlace}
        >
          {Icon && <Icon width={size} height={size} style={{ fill: color, color }} />}
        </div>
      )}
    </>
  );
};

export default IconContainer;